import { MenuItem } from "@mui/material";

export default (props) => {
	return <MenuItem {...props} />;
};
